import React from "react";
const autobind = require("class-autobind").default;
import shortid from "shortid";
import { FormGroup } from "../../form/group/index";
import { Input, InputNumber } from "../../form/input/index";
import { InputBox } from "../../form/input.box/index";
import { Button } from "../../button/index";
import { FaPlusCircle, FaMinusCircle, FaCopy } from "react-icons/fa";
import { Checkbox } from "../../form/checkbox/index";
import { Tooltip } from "../../tooltip/index";
import { FormTreeSelect } from "../../form/tree";
export class FieldTaxes extends React.Component {
    constructor(props) {
        super(props);
        autobind(this);
    }
    nodeGetDeepestChildrenValues = (node) => {
        let children = [];
        if (node.children) {
            for (const child of node.children) {
                if (child.children) {
                    children = [...children, ...this.nodeGetDeepestChildrenValues(child)];
                }
                else {
                    children.push(child.value);
                }
            }
        }
        return children;
    };
    gatherAllChildrenNodes = () => {
        let children = [];
        this.props.treeData.forEach((node) => {
            children = children.concat(this.nodeGetDeepestChildrenValues(node));
        });
        return children;
    };
    add = () => {
        const children = this.gatherAllChildrenNodes();
        const taxes = [...this.props.taxes];
        taxes.push({
            _id: shortid.generate(),
            name: "TAX",
            // @ts-ignore
            rate: 0,
            compound: false,
            dish_tax: children,
            tax_indicator_flag: false,
            tax_indicator_character: "*",
            tax_indicator_string: "* indicates a TAX free item.",
        });
        this.props.onChange(taxes);
    };
    copy(i) {
        const taxes = [...this.props.taxes];
        const tax = { ...taxes[i] };
        taxes.push(tax);
        this.props.onChange(taxes);
    }
    remove(i) {
        const taxes = ([...this.props.taxes]);
        taxes.splice(i, 1);
        this.props.onChange(taxes);
    }
    change(i, key, value) {
        const taxes = [...this.props.taxes];
        //@ ts-ignore
        taxes[i][key] = value;
        this.props.onChange(taxes);
    }
    render() {
        return (React.createElement("div", null,
            this.props.taxes.length === 0 &&
                React.createElement(Button, { size: "xs", color: "primary-inverse", type: "button", onClick: this.add }, "Create New Tax"),
            this.props.taxes.map((item, i) => {
                return (React.createElement("div", { key: i },
                    React.createElement("div", { className: "flex-line", style: { alignItems: "flex-end" } },
                        React.createElement(InputBox, { className: "no-round width32 text-center" },
                            React.createElement("p", { className: "big font-bold", style: { lineHeight: "36px" } }, i + 1)),
                        React.createElement("div", { className: "flex-line", style: { alignItems: "flex-end" } },
                            React.createElement(FormGroup, { className: "m-b-0", title: i === 0 ? "Name" : null, small_title: true, no_border: true },
                                React.createElement(Input, { className: "no-round", required: true, style: { width: "150px" }, value: item.name, onChange: (e) => this.change(i, "name", e.target.value) })),
                            React.createElement(FormGroup, { className: "m-b-0", title: i === 0 ? "Rate (%)" : null, small_title: true, no_border: true },
                                React.createElement(InputNumber, { type: "number", required: true, className: "no-round", style: { width: "150px" }, value: item.rate, step: "0.001", change: (v) => this.change(i, "rate", v) })),
                            React.createElement(FormGroup, { className: "m-b-0", title: i === 0 ? "Compound" : null, small_title: true, no_border: true },
                                React.createElement(InputBox, { className: "no-round flex-center width75" },
                                    React.createElement(Checkbox, { id: `${i}-tax-compound`, checked: item.compound, onChange: (e) => this.change(i, "compound", e.target.checked) })))),
                        (this.props.taxes.length - 1) === i &&
                            React.createElement(Tooltip, { text: "Add", width: 65, position: "top" },
                                React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: this.add },
                                    React.createElement(FaPlusCircle, null))),
                        React.createElement(Tooltip, { text: "Delete", width: 65, position: "top" },
                            React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => this.remove(i) },
                                React.createElement(FaMinusCircle, null))),
                        React.createElement(Tooltip, { text: "Copy", width: 65, position: "top" },
                            React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => this.copy(i) },
                                React.createElement(FaCopy, null)))),
                    React.createElement("div", { style: { marginTop: "10px" } },
                        React.createElement("div", { className: "flex-line", style: { alignItems: "flex-end" } },
                            React.createElement("div", { style: { width: "32px" } }),
                            React.createElement(FormGroup, { className: "m-b-0", title: i === 0 ? "Symbol" : null, small_title: true, no_border: true },
                                React.createElement(Input, { className: "no-round", required: item.tax_indicator_flag === true, maxLength: 1, style: { width: "60px" }, value: item.tax_indicator_character, onChange: (e) => this.change(i, "tax_indicator_character", e.target.value) })),
                            React.createElement(FormGroup, { className: "m-b-0", title: i === 0 ? "Message" : null, small_title: true, no_border: true },
                                React.createElement(Input, { type: "string", required: item.tax_indicator_flag === true, className: "no-round", style: { width: "240px" }, value: item.tax_indicator_string, onChange: (e) => this.change(i, "tax_indicator_string", e.target.value) })),
                            React.createElement(FormGroup, { className: "m-b-0", title: i === 0 ? "Show Message?" : null, small_title: true, no_border: true },
                                React.createElement(InputBox, { className: "no-round flex-center width75" },
                                    React.createElement(Checkbox, { id: `${i}-tax-indicator`, checked: item.tax_indicator_flag, onChange: (e) => this.change(i, "tax_indicator_flag", e.target.checked) }))))),
                    i === 0 ? React.createElement("p", { style: { marginTop: "10px", marginLeft: "32px" } }, "These settings are to visually mark items that do NOT have the tax applied.") : React.createElement("p", null),
                    React.createElement("div", null,
                        React.createElement(FormGroup, { style: { marginTop: "10px", marginBottom: "10px" }, optional: false, title: "Eligible Items" },
                            React.createElement(FormTreeSelect, { id: `dish_tax`, selected: item.dish_tax || [], nodes: this.props.treeData, onChange: (values) => {
                                    this.change(i, "dish_tax", values);
                                } })),
                        React.createElement("br", null))));
            })));
    }
}
//# sourceMappingURL=index.js.map